import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data,
  })
}

export function getMSLoginUrl() {
  return request({
    url: '/auth/microsoft/redirect',
    method: 'get',
  })
}

export function msLoginCallback(code) {
  return request({
    url: 'login/microsoft',
    method: 'post',
    params: { code },
  })
}

export function logout(token) {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function Register(data) {
  return request({
    url: '/register',
    method: 'post',
    data,
  })
}

export function forgotPassword(data) {
  return request({
    url: '/forgot_password',
    method: 'post',
    data,
  })
}

export function resetPassword(data) {
  return request({
    url: '/reset_password',
    method: 'post',
    data,
  })
}

export function validateResetPasswordToken(data) {
  return request({
    url: '/reset_password/token-validation',
    method: 'post',
    data,

  })
}
export function emailVerificationCode(data) {
  return request({
    url: '/send-verification-code',
    method: 'post',
    data,
  })
}

export function verifyCode(data) {
  return request({
    url: '/verify-code',
    method: 'post',
    data,
  })
}

export function validateMicrosoftLogin(email) {
  return request({
    url: '/login/microsoft/validate',
    method: 'get',
    params: { email },
  })
}

export function validateMicrosoftSignup(institutionCode) {
  return request({
    url: '/login/microsoft/validate',
    method: 'get',
    params: { institution_code: institutionCode },
  })
}
